import React$1 from 'react';

const PlaySmall = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "11",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React$1.createElement("path", {
  d: "M.5.25v11.447l10.016-6.041L.5.25zm2 3.352l3.984 2.15L2.5 8.155V3.602z",
  fillRule: "nonzero"
}));

export default PlaySmall;
